import { useId, useRef, useState } from 'react';
import { ChevronDown, ListFilter } from 'lucide-react';

const OPTIONS = [
  ['active', '进行中'], ['disabled', '已关闭'], ['stopped', '已停止'], ['completed', '已完成'], ['cancelled', '已取消'],
] as const;

type FilterOption = readonly [string, string];
export function MessageMultiFilter({
  value,
  onChange,
  options,
  ariaLabel,
  allLabel,
  selectedLabel,
  legend,
}: {
  value: string[];
  onChange: (value: string[]) => void;
  options: readonly FilterOption[];
  ariaLabel: string;
  allLabel: string;
  selectedLabel: string;
  legend: string;
}) {
  const id = useId();
  const popup = useRef<HTMLDivElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const label = value.length === 1 ? options.find(([key]) => key === value[0])?.[1] : value.length ? selectedLabel.replace('{count}', String(value.length)) : allLabel;
  return <div className="message-status-filter">
    <button ref={trigger} type="button" className="secondary-button" aria-label={`${ariaLabel}：${label}`} aria-expanded={open} aria-controls={id} onClick={() => {
      if (open) { popup.current?.hidePopover(); return; }
      const bounds = trigger.current!.getBoundingClientRect();
      Object.assign(popup.current!.style, { left: `${Math.max(8, Math.min(bounds.left, innerWidth - 248))}px`, top: `${Math.min(bounds.bottom + 6, Math.max(8, innerHeight - 340))}px` });
      popup.current?.showPopover();
    }}><ListFilter size={15} />{label}<ChevronDown size={14} /></button>
    <div ref={popup} id={id} popover="auto" className="message-status-popup" onToggle={(event) => setOpen(event.newState === 'open')}>
      <fieldset><legend>{legend}</legend>{options.map(([key, name]) => <label key={key}><input type="checkbox" checked={value.includes(key)} onChange={(event) => onChange(event.target.checked ? [...value, key] : value.filter((item) => item !== key))} /><span className={`message-filter-dot ${key}`} />{name}</label>)}</fieldset>
      <footer><button className="text-button" disabled={!value.length} onClick={() => onChange([])}>清除筛选</button><button className="secondary-button small" onClick={() => { popup.current?.hidePopover(); trigger.current?.focus(); }}>完成</button></footer>
    </div>
  </div>;
}

export function MessageStatusFilter({ value, onChange }: { value: string[]; onChange: (value: string[]) => void }) {
  return <MessageMultiFilter value={value} onChange={onChange} options={OPTIONS} ariaLabel="筛选消息状态" allLabel="全部状态" selectedLabel="已选 {count} 项状态" legend="消息状态 · 可多选" />;
}
